import { Suspense, useMemo } from 'react';
import { Outlet, useMatches } from 'react-router';

import { BreadcrumbComponent, FlyBreadcrumbs } from '@fly/shared-ui';

export const BaseLayout = () => {
  const matches = useMatches();

  const breadcrumbs: BreadcrumbComponent[] = useMemo(
    () =>
      matches
        .filter((match: any) => match.handle?.Breadcrumb)
        .map((match: any) => match.handle?.Breadcrumb),
    [matches]
  );

  const actions: React.ComponentType[] = useMemo(
    () =>
      matches
        .filter((match: any) => match.handle?.Action)
        .map((match: any) => match.handle?.Action),
    [matches]
  );

  const Action = actions.at(-1);

  return (
    <div
      className='flex h-full w-full flex-col gap-fly-4'
      data-testid='runtime-environments'
    >
      <header className='min-h-8 flex items-center'>
        <FlyBreadcrumbs
          data-testid='runtime-environments-breadcrumbs'
          breadcrumbs={breadcrumbs}
        />
        {Action ? (
          <Suspense fallback={null}>
            <Action />
          </Suspense>
        ) : null}
      </header>
      <Outlet />
    </div>
  );
};
